import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Font = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Font({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 4C3.25 3.30964 3.80964 2.75 4.5 2.75H19.5C20.1904 2.75 20.75 3.30964 20.75 4V5.5C20.75 5.77614 20.5261 6 20.25 6H19.75C19.4739 6 19.25 5.77614 19.25 5.5V4.25H12.75V20.2513H14.5C14.7761 20.2513 15 20.4752 15 20.7513V21.2513C15 21.5275 14.7761 21.7513 14.5 21.7513H9.5C9.22386 21.7513 9 21.5275 9 21.2513V20.7513C9 20.4752 9.22386 20.2513 9.5 20.2513H11.25V4.25H4.75V5.5C4.75 5.77614 4.52614 6 4.25 6H3.75C3.47386 6 3.25 5.77614 3.25 5.5V4Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'font-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Font;
